<template>
    <span>
        <span class="avatar-rounded" :style="'background-image: url(' + externalUrl + ');'"></span>
    </span>
</template>
<script>
    export default {
        name: 'avatar',

        props: ['externalUrl']
    }
</script>

<style>
    .avatar-rounded {
        display: inline-block;
        background-color: #f7f9fc;
        border-radius: 50%;
        background-size: cover;
        background-position: top center;
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/PartnerAvatar.vue